// import PropTypes from 'prop-types'
// import React, { Component } from "react"

// import { connect } from "react-redux"
// import { withRouter } from "react-router-dom"
// import {
//   changeLayout,
//   changeSidebarTheme,
//   changeSidebarThemeImage,
//   changeSidebarType,
//   changeTopbarTheme,
//   changeLayoutWidth,
// } from "../../store/actions"

// // Layout Related Components
// import Header from "./Header"
// import Sidebar from "./Sidebar"
// import Footer from "./Footer"
// import Rightbar from "../CommonForBoth/RightSidebar"
// import MainService from '../../Services/MainService'
// import { MERCHANT_USER_TYPE_ID } from '../../Constants/MainKeys'

// class Layout extends Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
//     }
//     this.toggleMenuCallback = this.toggleMenuCallback.bind(this)
//   }

//   capitalizeFirstLetter = string => {
//     return string.charAt(1).toUpperCase() + string.slice(2)
//   }

//   componentDidMount() {
//     if (this.props.isPreloader === true) {
//       document.getElementById("preloader").style.display = "block"
//       document.getElementById("status").style.display = "block"

//       setTimeout(function () {
//         document.getElementById("preloader").style.display = "none"
//         document.getElementById("status").style.display = "none"
//       }, 2500)
//     } else {
//       document.getElementById("preloader").style.display = "none"
//       document.getElementById("status").style.display = "none"
//     }
//     window.scrollTo(0, 0)
//     if (this.props.leftSideBarTheme) {
//       this.props.changeSidebarTheme(this.props.leftSideBarTheme)
//     }
//     if (this.props.leftSideBarThemeImage) {
//       this.props.changeSidebarThemeImage(this.props.leftSideBarThemeImage)
//     }

//     if (this.props.layoutWidth) {
//       this.props.changeLayoutWidth(this.props.layoutWidth)
//     }

//     if (this.props.leftSideBarType) {
//       this.props.changeSidebarType(this.props.leftSideBarType)
//     }
//     if (this.props.topbarTheme) {
//       this.props.changeTopbarTheme(this.props.topbarTheme)
//     }
//   }
//   toggleMenuCallback = () => {
//     if (this.props.leftSideBarType === "default") {
//       this.props.changeSidebarType("condensed", this.state.isMobile)
//     } else if (this.props.leftSideBarType === "condensed") {
//       this.props.changeSidebarType("default", this.state.isMobile)
//     }
//   }
//   render() {
//     const { language, user } = this.props;
//     console.log(user);


//     return (
//       <React.Fragment>

//         <div id="preloader">
//           <div id="status">
//             <div className="spinner-chase">
//               <div className="chase-dot" />
//               <div className="chase-dot" />
//               <div className="chase-dot" />
//               <div className="chase-dot" />
//               <div className="chase-dot" />
//               <div className="chase-dot" />
//             </div>
//           </div>
//         </div>

//         <div id="layout-wrapper">
//           <Header toggleMenuCallback={this.toggleMenuCallback} />
//           {/* <div
//             className="help-line d-flex justify-content-end align-items-center px-3"
//             style={{ top: `${document.querySelector("header")?.offsetHeight}px` }}
//           >
//             <a
//               className='d-flex cursor-pointer text-dark'
//               href={`https://cryllex.${MainService.getUrlExtension()}/contact-us`}
//               target='_blank'
//             >
//               <p className='m-0 font-size-16 me-2 '>Help</p>
//               <i className='bx bxs-help-circle font-size-22'></i>
//             </a>
//           </div> */}
//           <Sidebar
//             theme={this.props.leftSideBarTheme}
//             type={this.props.leftSideBarType}
//             isMobile={this.state.isMobile}
//           />
//           <div className="main-content">
//             {console.log(user)
//             }
//             {
//               user && user.userTypeId === MERCHANT_USER_TYPE_ID ?
//                 <div className='step-line'>

//                 </div>
//                 : null
//             }
//             {this.props.children}
//           </div>
//           <Footer />
//         </div>
//         {this.props.showRightSidebar ? <Rightbar /> : null}
//       </React.Fragment>
//     )
//   }
// }

// Layout.propTypes = {
//   changeLayoutWidth: PropTypes.func,
//   changeSidebarTheme: PropTypes.func,
//   changeSidebarThemeImage: PropTypes.func,
//   changeSidebarType: PropTypes.func,
//   changeTopbarTheme: PropTypes.func,
//   children: PropTypes.object,
//   isPreloader: PropTypes.any,
//   layoutWidth: PropTypes.any,
//   leftSideBarTheme: PropTypes.any,
//   leftSideBarThemeImage: PropTypes.any,
//   leftSideBarType: PropTypes.any,
//   location: PropTypes.object,
//   showRightSidebar: PropTypes.any,
//   topbarTheme: PropTypes.any
// }

// const mapStatetoProps = state => {
//   return {
//     ...state.Layout,
//     language: state.Languages.language,
//     user: state.Login.user
//   }
// }
// export default connect(mapStatetoProps, {
//   changeLayout,
//   changeSidebarTheme,
//   changeSidebarThemeImage,
//   changeSidebarType,
//   changeTopbarTheme,
//   changeLayoutWidth,
// })(withRouter(Layout))


import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarThemeImage,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
} from "../../store/actions";
import { MERCHANT_USER_TYPE_ID } from "../../Constants/MainKeys";

// Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import Rightbar from "../CommonForBoth/RightSidebar";
import MainService from "../../Services/MainService";
import StepLine from "../StepLine/StepLine";

const Layout = ({ children, isPreloader, showRightSidebar }) => {
  const [isMobile] = useState(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
  const dispatch = useDispatch();

  const {
    leftSideBarTheme,
    leftSideBarThemeImage,
    leftSideBarType,
    layoutWidth,
    topbarTheme,
  } = useSelector(state => state.Layout);

  const { language } = useSelector(state => state.Languages);
  const { user } = useSelector(state => state.Login);

  useEffect(() => {
    if (isPreloader) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(() => {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }

    window.scrollTo(0, 0);

    if (leftSideBarTheme) dispatch(changeSidebarTheme(leftSideBarTheme));
    if (leftSideBarThemeImage) dispatch(changeSidebarThemeImage(leftSideBarThemeImage));
    if (layoutWidth) dispatch(changeLayoutWidth(layoutWidth));
    if (leftSideBarType) dispatch(changeSidebarType(leftSideBarType));
    if (topbarTheme) dispatch(changeTopbarTheme(topbarTheme));
  }, [
    isPreloader,
    leftSideBarTheme,
    leftSideBarThemeImage,
    layoutWidth,
    leftSideBarType,
    topbarTheme,
    dispatch,
  ]);

  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarType("condensed", isMobile));
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarType("default", isMobile));
    }
  };

  return (
    <>
      <div id="preloader">
        <div id="status">
          <div className="spinner-chase">
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
          </div>
        </div>
      </div>

      <div id="layout-wrapper">
        <Header toggleMenuCallback={toggleMenuCallback} />
        {/* <div
          className="help-line d-flex justify-content-end align-items-center px-3"
          style={{ top: `${document.querySelector("header")?.offsetHeight}px` }}
        >
          <a
            className='d-flex cursor-pointer text-dark'
            href={`https://cryllex.${MainService.getUrlExtension()}/contact-us`}
            target='_blank'
          >
            <p className='m-0 font-size-16 me-2 '>Help</p>
            <i className='bx bxs-help-circle font-size-22'></i>
          </a>
        </div> */}
        <Sidebar theme={leftSideBarTheme} type={leftSideBarType} isMobile={isMobile} />
        <div className="main-content">
          {/* {user && user.userTypeId === MERCHANT_USER_TYPE_ID && <div className="step-line"><StepLine /></div>} */}
          {children}
        </div>
        <Footer />
      </div>

      {showRightSidebar && <Rightbar />}
    </>
  );
};

export default Layout;
